import './featured-product-card.scss';
